'use client'

import { useState, useEffect } from 'react'

export function useBreakpoints() {
  const [screenWidth, setScreenWidth] = useState(0)

  useEffect(() => {
    const updateScreenWidth = () => {
      setScreenWidth(window.innerWidth)
    }

    window.addEventListener('resize', updateScreenWidth)
    updateScreenWidth()

    return () => window.removeEventListener('resize', updateScreenWidth)
  }, [])

  return {
    isSmallest: screenWidth <= 369,
    isSmall: screenWidth <= 469,
    isSemiMedium: screenWidth <= 669,
    isMedium: screenWidth <= 769,
    isBig: screenWidth <= 869,
    isLarge: screenWidth <= 1280,
    isBigger: screenWidth <= 1040,
    isLargest: screenWidth <= 1440,
  }
}
